export const loadedSavedData = data => {
  return {
    type: 'insert_saved_search_data',
    payload: data
  }
}

export const removeSavedData = () => {
  return {
    type: 'insert_saved_search_data',
    payload: []
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/scenes/Filters/scenes/ProfileFacts/scenes/Results/actions.js